import { Component, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromDataServices from '../../data-services';
import { RecalculateSchedule } from '../../data-services/recalculate-transactions/recalculate-schedules';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-schedules-presenter',
    templateUrl: './schedules-presenter.component.html',
    styleUrls: ['./schedules-presenter.component.scss'],
    standalone: false
})
export class SchedulesPresenterComponent
    extends DisplayErrors<fromDataServices.RecalculateSchedules.RecalculateSchedule>
    implements OnInit
{
    private SchedulesSubject = new ReplaySubject<
        Array<fromDataServices.RecalculateSchedules.RecalculateSchedule>
    >(1);
    private _schedules: Array<fromDataServices.RecalculateSchedules.RecalculateSchedule>;

    @Input() set schedules(
        value: Array<fromDataServices.RecalculateSchedules.RecalculateSchedule>
    ) {
        // this._schedules = value;
        this._schedules = value.sort(
            (a, b) =>
                a.PeriodStartDate?.getTime() - b.PeriodStartDate?.getTime()
        );
        this.SchedulesSubject.next(value);
        if (value && value.length > 0) {
            this.IsStatusPending = value.some(
                x =>
                    x.PeriodStatus.includes('pending') == true ||
                    x.PeriodStatus.includes('PENDING') == true
            );
            this.log.verbose({
                type: 'schedules:set',
                IsStatusPending: this.IsStatusPending
            });
            this.StatusPending.next(this.IsStatusPending);
            this.processingText = value[0].Userlogdetail;
            this.processingMsg = [
                { severity: 'info', summary: '', detail: this.processingText }
            ];
            this.showTimer = value[0].Timer;
        }
    }
    get schedules(): Array<fromDataServices.RecalculateSchedules.RecalculateSchedule> {
        return this._schedules;
    }

    selectedSchedule: RecalculateSchedule;

    selectedProcessScheduleIDs: number[];

    processingScheduleString: string;

    moment: any;

    IsStep1BtnDisabled = true;
    IsStep2BtnDisabled = true;

    IsStatusPending: boolean;

    checkedRow: fromDataServices.RecalculateSchedules.RecalculateSchedule;

    @Output() GetProcessScheduleIDs = new ReplaySubject<any>(1);

    @Output() GetStep1BtnStatus = new ReplaySubject<any>(1);
    @Output() GetStep2BtnStatus = new ReplaySubject<any>(1);

    @Output() GetContracts = new ReplaySubject<{
        PeriodStartDate: Date;
        PeriodEndDate: Date;
    }>(1);

    @Output() StatusPending = new ReplaySubject<any>(1);

    @Input() IsDialogVisible$: BehaviorSubject<boolean>;

    processingText: string;

    processingMsg: { severity: string; summary: string; detail: string }[];

    row: any;

    showTimer = false;

    rowData: RecalculateSchedule;

    processIDs: any[] = [];

    @Input() dialogAction$: Observable<string>;
    dialogAction: string;

    @Input() clearSelectedSchedules$: Observable<boolean>;
    clearSelectedSchedules: boolean;

    active = true;

    constructor(private log: LoggingService) {
        super();
        this.moment = moment;
    }

    ngOnInit(): void {
        setTimeout(() => {
            if (this.schedules.length > 0) {
                this.selectedSchedule = this.schedules[0];
                this.onScheduleSelected({ data: this.selectedSchedule });
            }
        }, 500);

        this.setupSubscriptions();
    }

    ngOnDestroy() {
        this.active = false;
    }

    setupSubscriptions() {
        if (this.dialogAction$) {
            this.dialogAction$
                .pipe(takeWhile(() => this.active == true))
                .subscribe(x => {
                    if (x && x == 'apply') {
                        this.selectedSchedule = this.processIDs[0];
                    } else if (x && x == 'discard') {
                        this.selectedSchedule = this.processIDs[0];
                    }
                });
        }
        if (this.clearSelectedSchedules$) {
            this.clearSelectedSchedules$
                .pipe(takeWhile(() => this.active == true))
                .subscribe(x => {
                    if (x == true) {
                        this.selectedProcessScheduleIDs = [];
                    }
                });
        }
    }

    onCheckboxChange($event, rowData) {
        if (rowData == this.selectedSchedule) {
            this.row = document.getElementById(
                `row-${rowData.ProcessScheduleID}`
            );
            this.row.classList.add('highlight');
        }
        this.checkedRow = rowData;
        this.processingScheduleString = '';
        this.selectedProcessScheduleIDs.forEach(id => {
            this.processingScheduleString += `${id},`;
        });
        this.GetProcessScheduleIDs.next(this.selectedProcessScheduleIDs.join());
        this.log.verbose({
            type: 'SchedulesPresenterComponent',
            method: 'onCheckboxChange',
            data: this.selectedProcessScheduleIDs
        });
        const index = this.schedules.findIndex(
            x => x.ProcessScheduleID == rowData.ProcessScheduleID
        );
        if (index != -1) {
            this.schedules[index] = {
                ...rowData,
                selected: $event.checked.includes(this.schedules[index].id)
            };
            if (this.schedules.some(x => x.selected == true)) {
                this.IsStep1BtnDisabled = false;
                if (
                    this.schedules
                        .filter(x => x.selected == true)
                        .every(x => !!x.QBImportDate)
                ) {
                    this.IsStep2BtnDisabled = false;
                }
            } else {
                this.IsStep1BtnDisabled = true;
                this.IsStep2BtnDisabled = true;
            }
            this.GetStep1BtnStatus.next(this.IsStep1BtnDisabled);
            this.GetStep2BtnStatus.next(this.IsStep2BtnDisabled);
        }
    }

    onScheduleSelected(value) {
        // this.IsDialogVisible$.next(true);
        this.processIDs.push(value.data);
        if (this.processIDs.length > 2) {
            this.processIDs.splice(0, 1);
        }
        this.rowData = value;
        if (this.row) {
            this.row.classList.remove('highlight');
        }
        this.GetContracts.next({
            PeriodStartDate: value.data.PeriodStartDate,
            PeriodEndDate: value.data.PeriodEndDate
        });
    }
}
